<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划名称" prop="planName">
              <a-input placeholder="请输入计划名称" v-model="model.planName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="创建人">
              <a-select
                :filter-option="filterOption"
                :not-found-content="null"
                :show-arrow="false"
                @search="remoteUserList"
                allowClear
                placeholder="请选择创建人"
                show-search
                v-model:value="model.createBy"
              >
                <a-select-option :key="item.id" :value="item.id" v-for="item in UserOptions">
                  {{
                  item.realname
                  }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检路线" prop="routeId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.custom_szwt_patrol_route,route_name,id"
                placeholder="请输入巡检路线"
                v-model="model.routeId"
              />
              <a-button
                :disabled="!formDisabled"
                :style="{'margin-right': '-100px'}"
                @click="handleTo3d()"
                type="link"
              >查看</a-button>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="12" v-show="false">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划状态" prop="planStatus">
              <j-dict-select-tag
                dictCode="patrol_plan_status"
                disabled
                placeholder="请输入计划状态"
                v-model="model.planStatus"
              />
            </a-form-model-item>
          </a-col>

          <a-divider></a-divider>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划类型" prop="planCycleType">
              <a-radio-group @change="planCycleTypeChange" button-style="solid" v-model:value="model.planCycleType">
                <a-radio-button value="1">周期</a-radio-button>
                <a-radio-button value="2">指定每日时间</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="任务周期"
              prop="planCycle"
              v-if="model.planCycleType == '1'"
            >
              <a-radio-group v-model:value="model.planCycle">
                <a-radio :value="'0 0/15 * * * ?'">15分钟</a-radio>
                <a-radio :value="'0 0/30 * * * ?'">30分钟</a-radio>
                <a-radio :value="'0 0 0/1 * * ?'">1小时</a-radio>
                <a-radio :value="'0 0 0/2 * * ?'">2小时</a-radio>
                <a-radio :value="'0 0 0/3 * * ?'">3小时</a-radio>
                <a-radio :value="'0 0 0/4 * * ?'">4小时</a-radio>
                <a-radio :value="'0 0 0/6 * * ?'">6小时</a-radio>
                <a-radio :value="'0 0 0/8 * * ?'">8小时</a-radio>
                <a-radio :value="'0 0 0/12 * * ?'">12小时</a-radio>
                <a-radio :value="'0 0 0/24 * * ?'">24小时</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="任务周期"
              prop="planCycle"
              v-if="model.planCycleType == '2'"
            >
              <a-tabs size="small" v-model="curtab">
                <a-tab-pane key="minute" tab="分">
                  <minute-ui v-model="minute"></minute-ui>
                </a-tab-pane>
                <a-tab-pane key="hour" tab="时">
                  <hour-ui v-model="hour"></hour-ui>
                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
                                    <a-form-model-item label="下次执行时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="nextTime">
                                        <j-date placeholder="请选择下次执行时间" v-model="model.nextTime" :showTime="true" date-format="YYYY-MM-DD HH:mm:ss" style="width:45%" />
                                    </a-form-model-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="近十次执行时间（不含年）">
              <a-textarea :rows="10" :value="preTimeList" disabled type="textarea" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { getUserList } from '@/api/api'
  import cronValidator from '@/components/jeecg/JEasyCron/validator'
  import { simpleDebounce } from '@/utils/util'
  import CronParser from 'cron-parser'
  import dateFormat from '@/components/jeecg/JEasyCron/format-date'
  import MinuteUi from './tabs/minute'
  import HourUi from './tabs/hour'
  import { validatenotnull, validatenull } from '@/utils/validate'

  export default {
    name: 'YwIntelligentPatrolPlanForm',
    components: {
      MinuteUi,
      HourUi
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          planName: '',
          planStatus: '',
          planCycleType: '',
          planCycle: '',
          createBy: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 }
        },
        confirmLoading: false,
        validatorRules: {
          planName: [{ required: true, message: '请输入计划名称!' }],
          planCycleType: [{ required: true, message: '请选择计划类型!' }],
          planCycle: [{ required: true, message: '请输入cron表达式!' }, { validator: cronValidator }]
        },
        url: {
          add: '/maintenance/ywIntelligentPatrolPlan/add',
          edit: '/maintenance/ywIntelligentPatrolPlan/edit',
          queryById: '/maintenance/ywIntelligentPatrolPlan/queryById'
        },
        UserOptions: [],
        preTimeList: '执行预览，会忽略年份参数',
        curtab: 'minute',
        second: '*',
        minute: '*',
        hour: '*',
        day: '*',
        month: '*',
        week: '?',
        year: '*',
        inputValues: { second: '', minute: '', hour: '', day: '', month: '', week: '', year: '', cron: '' },
        hideSecond: false,
        hideYear: true,
        cronValue: ''
      }
    },
    computed: {
      cronValue_c () {
        let result = []
        if (!this.hideSecond) result.push(this.second ? this.second : '*')
        result.push(this.minute ? this.minute : '*')
        result.push(this.hour ? this.hour : '*')
        result.push(this.day ? this.day : '*')
        result.push(this.month ? this.month : '*')
        result.push(this.week ? this.week : '?')
        if (!this.hideYear && !this.hideSecond) result.push(this.year ? this.year : '*')
        return result.join(' ')
      },
      cronValue_c2 () {
        const v = this.cronValue_c
        if (this.hideYear || this.hideSecond) return v
        const vs = v.split(' ')
        if (vs.length >= 6) {
          // 将 Quartz 星期 的规则转换为 CronParser 的规则
          vs[5] = this.convertQuartzWeekToCParser(vs[5])
        }
        return vs.slice(0, vs.length - 1).join(' ')
      },
      formDisabled () {
        return this.disabled
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    watch: {
      cronValue (newVal, oldVal) {
        if (newVal === this.cronValue_c) {
          // console.info('same cron value: ' + newVal)
          return
        }
        this.formatValue()
      },
      cronValue_c (newVal, oldVal) {
        this.calTriggerList1()
        this.$set(this.model, 'planCycle', newVal)
        this.assignInput()
      },
      minute () {
        if (this.second === '*') {
          this.second = '0'
        }
      },
      hour () {
        if (this.minute === '*') {
          this.minute = '0'
        }
      },
      day (day) {
        if (day !== '?' && this.hour === '*') {
          this.hour = '0'
        }
      },
      'model.planCycle' (newVal, oldVal) {
        this.calTriggerList()
        this.$emit('change', newVal)
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      this.remoteUserList()
    },
    methods: {
      add () {
        // 统一设置默认值
        this.modelDefault.planName = ''
        this.modelDefault.planStatus = 0
        this.modelDefault.planCycleType = '1'
        this.modelDefault.planCycle = '0 0/30 * * * ?'
        this.modelDefault.createBy = this.userInfo.id
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        if (validatenotnull(this.model.planCycleType && this.model.planCycleType == '2')) {
          this.$nextTick(() => {
            this.cronValue = this.model.planCycle
          })
        }
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      remoteUserList (query) {
        let params = {
          username: query
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions = res.result.records
        })
      },
      calTriggerList: simpleDebounce(function () {
        this.calTriggerListInner()
      }, 500),
      calTriggerListInner () {
        const format = 'yyyy-MM-dd hh:mm:ss'
        const options = {
          currentDate: dateFormat(new Date(), format)
        }
        const iter = CronParser.parseExpression(this.model.planCycle, options)
        const result = []
        for (let i = 1; i <= 10; i++) {
          result.push(dateFormat(new Date(iter.next()), format))
        }
        this.preTimeList = result.length > 0 ? result.join('\n') : '无执行时间'
      },
      planCycleTypeChange () {
        if (this.model.planCycleType == '1') {
          this.model.planCycle = '0 0/30 * * * ?'
        } else if (this.model.planCycleType == '2') {
          this.cronValue = '0 0 0 * * ?'
          this.model.planCycle = '0 0 0 * * ?'
          this.formatValue()
          this.$nextTick(() => {
            this.calTriggerListInner1()
          })
        }
      },
      assignInput () {
        Object.assign(this.inputValues, {
          second: this.second,
          minute: this.minute,
          hour: this.hour,
          day: this.day,
          month: this.month,
          week: this.week,
          year: this.year,
          cron: this.cronValue_c
        })
      },
      formatValue () {
        if (!this.cronValue) return
        const values = this.cronValue.split(' ').filter(item => !!item)
        if (!values || values.length <= 0) return
        let i = 0
        if (!this.hideSecond) this.second = values[i++]
        if (values.length > i) this.minute = values[i++]
        if (values.length > i) this.hour = values[i++]
        if (values.length > i) this.day = values[i++]
        if (values.length > i) this.month = values[i++]
        if (values.length > i) this.week = values[i++]
        if (values.length > i) this.year = values[i]
        this.assignInput()
      },
      // 将 Quartz 星期 的规则转换为 CronParser 的规则：
      // Quartz 的规则：1 = 周日，2 = 周一，3 = 周二，4 = 周三，5 = 周四，6 = 周五，7 = 周六
      // CronParser 的规则： 0 = 周日，1 = 周一，2 = 周二，3 = 周三，4 = 周四，5 = 周五，6 = 周六，7 = 周日
      convertQuartzWeekToCParser (week) {
        let convert = v => {
          if (v === '0') {
            return '1'
          }
          if (v === '1') {
            return '0'
          }
          return (Number.parseInt(v) - 1).toString()
        }
        // 匹配示例 1-7 or 1/7
        let patten1 = /^([0-7])([-/])([0-7])$/
        // 匹配示例 1,4,7
        let patten2 = /^([0-7])(,[0-7])+$/
        if (/^[0-7]$/.test(week)) {
          return convert(week)
        } else if (patten1.test(week)) {
          return week.replace(patten1, ($0, before, separator, after) => {
            if (separator === '/') {
              return convert(before) + separator + after
            } else {
              return convert(before) + separator + convert(after)
            }
          })
        } else if (patten2.test(week)) {
          return week
            .split(',')
            .map(v => convert(v))
            .join(',')
        }
        return week
      },
      calTriggerList1: simpleDebounce(function () {
        this.calTriggerListInner1()
      }, 500),
      calTriggerListInner1 () {
        // 设置了回调函数
        if (this.remote) {
          this.remote(this.cronValue_c, +new Date(), v => {
            this.preTimeList = v
          })
          return
        }
        const format = 'yyyy-MM-dd hh:mm:ss'
        const options = {
          currentDate: dateFormat(new Date(), format)
        }
        const iter = CronParser.parseExpression(this.cronValue_c2, options)
        const result = []
        for (let i = 1; i <= 10; i++) {
          result.push(dateFormat(new Date(iter.next()), format))
        }
        this.preTimeList = result.length > 0 ? result.join('\n') : '无执行时间'
      },
      handleTo3d () {
        const iframeWindow = document.getElementById('commentIframegeneral-3d--visualView-#-')
        if (iframeWindow) {
          iframeWindow.contentWindow.postMessage('lineshow', '*')
          this.$router.push({ path: '/general/3d' })
        } else {
          this.$message.info('请先加载三维模型')
        }
      }
    }
  }
</script>
